module.exports = __webpack_public_path__ + "static/media/8.655f32f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/8.jpg
// module id = 199
// module chunks = 0